import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  avatar: {
    backgroundColor: "#FFC7C3",
    width: "62px",
    height: "62px",
    alignSelf: "center",
    [theme.breakpoints.down("xs")]: {
      width: "40px",
      height: "40px",
    },
  },
  userIcon: {
    color: theme.palette.error.main,
    fontSize: "34px",

    [theme.breakpoints.down("xs")]: {
      fontSize: "25px",
    },
  },
  userName: {
    textAlign: "left",
    fontSize: "18px",
    fontWeight: 550,
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },

  roleName: {
    fontSize: "14px",
    textAlign: "left",
    marginTop: "5px",
    color: "#9A9A9A",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
}))

export default styles
